import { LucideMapPin, LucidePhone } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineMapPin, HiOutlinePhone } from "react-icons/hi2";
import { Badge } from "rsuite";

const TopBanner = ({
  data,
  dynamicData,
  dynamicData1,
  dd,
  dd1,
  country,
  city,
  images,
  confirmation
}) => {
  const { t } = useTranslation();

  return (
    <div className="   rounded  bg-white">


      <div>
        <div className="position-relative">
          <img
            src={images[0]?.image_url}
            alt="hotel_img"
            className="rounded-end object-fit-cover w-100"
          
            height={200}
          />
          <div className="position-absolute bottom-0 start-0 p-2 text-white  w-100 rounded-bottom" style={{ background: 'linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent)' }}>
            <h5 className="mb-0 " >{data}</h5>
          </div>
        </div>

        <div className={`ms-4 mt-2 me-1 status-badge ${dd === "draft" ? "status-pending" : "pending" ? "status-pending" : "accepted" ? "status-confirmed" : "status-cancelled"}`}>
          {t(dynamicData1)}
        </div>

        <Badge className={`me-1 status-badge ${dd === 0 ? "status-cancelled" : "status-completed"}`} content={dd === 0 ? t("non bookable") : t("bookable")} />
        <div className="fs-6 my-2 ps-4">
          <LucideMapPin className="text-blue" size={18} /> {city},{country}
        </div>

        <div className="fs-6  mt-1 ps-4 pb-3">
          <LucidePhone className="text-blue" size={16} /> {t(dd1)}
        </div>
      </div>

    </div>
  );
};

export default TopBanner;
